import { toast } from 'react-toastify';

//author-saksham.sharma
//for displaying generc toast 
export const ShowToastUtil = (message, type = 'info') => {
    switch (type) {
        case 'success':
            toast.success(message);
            break;
        case 'error':
            toast.error(message);
            break;
        case 'info':
            toast.info(message);
            break;
        case 'warning':
            toast.warn(message);
            break;
        default:
            toast(message);
            break;
    }
};
//end
